import React from 'react'
import { Breadcrumb, Button, Flex, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ArrowRightOutlined, BulbOutlined, HomeOutlined } from '@ant-design/icons'
import { h5SketchProject, h5SketchLogs } from './h5Routes'

function FrontSketchDesc(props) {
    const navigate = useNavigate()
    const item = props.data || null
    const { bxm_id, yh_name, bxmxq_name, bxmbb_name, bxm_name, yh_id } = props
    return (
        <div style={{ marginTop: 12, position: 'relative' }}>
            <Flex vertical gap={12}>
                <Breadcrumb
                    items={[
                        {
                            title: (
                                <a
                                    onClick={() => {
                                        navigate(h5SketchProject(bxm_id))
                                    }}
                                >
                                    <HomeOutlined /> 首页
                                </a>
                            ),
                        },
                        { title: yh_name },
                        { title: bxmxq_name },
                        { title: bxmbb_name },
                    ]}
                />
                <Button type="primary" block onClick={() => navigate(h5SketchProject(bxm_id))}>
                    返回上一级
                </Button>
            </Flex>

            {item ? (
                <>
                    <div style={{ textAlign: 'center', marginTop: 16 }}>
                        <img
                            src={`/api/assets/images/application/${item.bxmbb_image || item.bxmbb_name}`}
                            alt={item.bxmbb_name || ''}
                            style={{
                                width: '100%',
                                maxWidth: '100%',
                                height: 'auto',
                                objectFit: 'cover',
                                display: 'block',
                                margin: '0 auto',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                border: '2px #000 solid',
                            }}
                            onError={(e) => {
                                e.target.src = '/img/home/logo.png'
                            }}
                        />
                    </div>
                    <Space direction="vertical" style={{ marginTop: 12, fontSize: 15, lineHeight: 1.6, color: '#000', width: '100%' }}>
                        <BulbOutlined />
                        <div dangerouslySetInnerHTML={{ __html: item.bxmbb_content }} />
                    </Space>
                    <div style={{ marginTop: 12, textAlign: 'right' }}>
                        <a
                            onClick={() => {
                                navigate(
                                    h5SketchLogs({
                                        bxmbb_id: item.bxmbb_id,
                                        bxm_id,
                                        bxmxq_name,
                                        bxmbb_name,
                                        yh_name,
                                        bxm_name,
                                        yh_id,
                                    })
                                )
                            }}
                        >
                            修改日志 <ArrowRightOutlined />
                        </a>
                    </div>
                </>
            ) : (
                <div
                    style={{
                        textAlign: 'center',
                        padding: '40px 16px',
                        color: '#999',
                        fontSize: 15,
                    }}
                >
                    <div style={{ fontSize: 40, marginBottom: 12 }}>📷</div>
                    <div>暂无图片内容</div>
                </div>
            )}
        </div>
    )
}

export default FrontSketchDesc
